export default  {
  bindings: {
    stock: '<',
  },
  controller: 'stockListController',
  template: require('../views/stock.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/components/stock.list.component.js